
























import { Vue, Component, Prop } from "vue-property-decorator";
import SocialLinks from "@/components/SocialLinks.vue";
import moment from "moment";
import { mapGetters, mapState } from "vuex";

const VasSidebarWeshopeProps = Vue.extend({
  inheritAttrs: false,
  computed: {
    ...mapState('global', [
      'cart'
    ]),
    ...mapGetters("vas", ["hasEcommerceDelivery"]),
  },
});

@Component({
  name: "vas-sidebar-weshope",
  components: {
    SocialLinks,
  },
})
export default class VasSidebarWeshope extends VasSidebarWeshopeProps {
  @Prop() readonly merchant!: MerchantStore;
  @Prop() readonly merchantDetails!: MerchantDetails;
  @Prop() readonly shopDetails!: MerchantShopDetails;

  showMoreInfo = false;

  get addressLine() {
    if (this.shopDetails) {
      const address = this.shopDetails;
      return `
        ${address.street}, ${address.streetNumber}
        ${address.province}, ${address.postalCode}
        ${address.country}
      `;
    }
    return "...";
  }

  toggleMoreInfo() {
    this.showMoreInfo = !this.showMoreInfo;
  }

  moment(data: string) {
    return moment(data);
  }

  getIsVasOrderAndPay() {
      return this.cart.vasType == 'ORDER_AND_PAY';
  }
}
